import React from "react";
import "../css/Create_common_loader.css";

function Common_loader() {

    return (
        <div className="Create_common_loader">
            <p>Creating, please wait...</p>
        </div>
    )

}

export default Common_loader;